import { Injectable } from '@angular/core';

import { IUiChangeHandler } from './ui-change-handler';
import { IUiState } from './ui-manager.state';

@Injectable({ providedIn: 'root' })
export class UiManagerService {
    private handlers: IUiChangeHandler[] = [];

    registerUiHandler(handler: IUiChangeHandler): void {
        this.handlers.push(handler);
    }

    async updateUi(prev: IUiState, next: IUiState): Promise<any> {
        for (const handler of this.handlers) {
            handler.updateUi(prev, next);
        }
    }
}
